export enum InteractionType {
  Question = 0,
  Guess = 1,
}
